// "Vessel status" tiles (src/lib/dashboardCore.js buildTiles): Maintenance, Ship documents, Crew certificates, Drills, Equipment,
// Stock - the first thing under the vessel strip on the Dashboard and at the top of the phone Today screen (2 per row there).
// A tile opens its page filtered on its headline (Maintenance -> Overdue, Stock -> Out of Stock ...); all in order -> the page unfiltered.
import '../styles/dashboard-v2.css'

export default function VesselStatusTiles({ tiles, onPick, compact = false }) {
  if (!tiles || !tiles.length) return null
  return (
    <section className={'dv-status' + (compact ? ' compact' : '')} aria-labelledby="dv-st-h">
      <h2 className="dv-h" id="dv-st-h" style={{ margin: '0 0 10px' }}>Vessel status</h2>
      <div className="dv-tiles">
        {tiles.map(t => (
          // the headline is the problem ("67 overdue") in the status colour, one full-width status bar (red / orange / green), the total small underneath
          <button key={t.key} type="button" data-tile={t.key} data-filter={t.filter || ''} className={'dv-card dv-tile st-' + t.status + (t.setup ? ' setup' : '')} onClick={() => onPick && onPick(t)}
            aria-label={t.label + ': ' + (t.setup ? 'set up - nothing recorded yet' : t.badge + ' - ' + (t.headline ? t.headline.n + ' ' + t.headline.text : 'all in order') + ', ' + t.sub) + (t.filter ? ' - opens ' + t.label + ' filtered on ' + t.filter : '')}>
            <span className="dv-h">{t.label}</span>
            {t.setup ? <span className="n">Set up</span>
              : t.headline ? <span className={'n ' + t.status}>{t.headline.n}<span className="u">{t.headline.text}</span></span>
              : <span className="n green ok">All in order</span>}
            <span className={'dv-st-bar ' + t.status} aria-hidden="true" />
            <span className="dv-sub">{t.sub}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
